import type { TIcon } from '../../types';

export function isRenderableSignupIcon(icon: unknown): icon is TIcon {
  if (!icon || typeof icon !== 'object' || Array.isArray(icon)) {
    return false;
  }

  const o = icon as Record<string, unknown>;

  if (Object.keys(o).length === 0) {
    return false;
  }

  if (o.type === 'icon') {
    return (
      typeof o.iconName === 'string' && o.iconName.length > 0 && typeof o.iconType === 'string' && o.iconType.length > 0
    );
  }

  if (o.type === 'emoji') {
    return typeof o.content === 'string' && o.content.length > 0;
  }

  return false;
}
